import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { TranslateScopes } from '@cloud-twin-v2/cloud-twin-shared/core/translate-scopes';
import { MasterOperatorSingleSettings } from '../master-operator-single/master-operator-single-settings';
import { MasterOperatorType } from '../models/master-operator-type';

const COMPONENT_SELECTOR = 'tc-master-operator-connect-popup.component';
@Component({
    selector: COMPONENT_SELECTOR,
    templateUrl: './master-operator-connect-popup.component.html',
    styleUrls: ['./master-operator-connect-popup.component.scss'],
    standalone: false
})
export class MasterOperatorConnectPopup implements OnInit {
  T_SCOPE = `${TranslateScopes.MasterOperator}.${COMPONENT_SELECTOR}`;
  masterOperatorConnectSettings: MasterOperatorConnectPopupConfiguration;
  masterInstanceIds: string[];

  titleKey: string;
  settings: MasterOperatorSingleSettings;
  configuration: MasterOperatorSingleSettings;
  isValid: boolean;

  constructor(
    private dialogRef: MatDialogRef<MasterOperatorConnectPopup>,
    @Inject(MAT_DIALOG_DATA) parameters: MasterOperatorConnectPopupConfiguration
  ) {
    this.masterOperatorConnectSettings = parameters;
    this.titleKey = `${this.T_SCOPE}.${
      parameters.modifyExistingOperators ? 'title-configure' : 'title-connect'
    }`;
  }

  ngOnInit(): void {
    this.masterInstanceIds = this.masterOperatorConnectSettings.realtimeIds;

    let settings = new MasterOperatorSingleSettings({
      groupId: this.masterOperatorConnectSettings.settings.groupId,
      type: MasterOperatorType.Operator,
    });

    if (this.masterOperatorConnectSettings.modifyExistingOperators) {
      settings = new MasterOperatorSingleSettings({
        ...this.masterOperatorConnectSettings.settings,
      });
    }

    this.settings = settings;
  }

  cancel(_) {
    this.dialogRef.close(false);
  }

  connect() {
    this.dialogRef.close(this.configuration);
  }

  onConfigured(configuration: MasterOperatorSingleSettings) {
    this.configuration = configuration;
  }

  onValidChanged(isValid: boolean) {
    this.isValid = isValid;
  }
}

export class MasterOperatorConnectPopupConfiguration {
  settings: MasterOperatorSingleSettings;
  realtimeIds?: string[];
  modifyExistingOperators: boolean;

  constructor(init: Partial<MasterOperatorConnectPopupConfiguration>) {
    Object.assign(this, init);
  }
}
